import { Store } from '@tanstack/react-store';

export type confirmerStoreType = {
    isOpen: boolean;
    title: string;
    resolve?: (value: boolean) => void;
};
export const confirmerStore = new Store<confirmerStoreType>({
    isOpen: false,
    title: '',
});

export function showConfirm(title: string): Promise<boolean> {
    return new Promise((resolve) => {
        confirmerStore.setState(() => ({
            isOpen: true,
            title,
            resolve,
        }));
    });
}

export function handleConfirm(confirmed: boolean) {
    const { resolve } = confirmerStore.state;
    if (resolve) {
        resolve(confirmed);
    }
    confirmerStore.setState(() => ({ isOpen: false, title: '', resolve: undefined }));
}
